import Cookies from 'js-cookie'
import storage from '@/utils/storage'
const state = {
  token: Cookies.get('Admin-Token'),
  stepActiveIndex: 0,
  showLogin: false,
  checkedEmail: '',
  isEmailBind: '',
  user: storage.get('user'),
  uid: storage.get('uid'),
  redirect: ''
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js